import { type CommonErrorResponses as LinkCommonErrorResponses } from '../links/CommonErrorResponses';
import { type SetCompanyLogoRequest as SchemaSetCompanyLogoRequest } from '../schemas/SetCompanyLogoRequest';

/**
 * ‼️ Файл сформирован автоматически. Не редактировать вручную.
 *
 * @tags Company
 */
export const SetCompanyLogoContentType = 'application/json' as const;
export type SetCompanyLogoRequest = SchemaSetCompanyLogoRequest;
export type SetCompanyLogoResponses = LinkCommonErrorResponses & {};
export type SetCompanyLogoResponseSuccess = undefined;
export type SetCompanyLogoSearchParams = undefined;
export type SetCompanyLogoPathParameters = undefined;
export const SetCompanyLogoUrl = '/company/logo' as const;
export const SetCompanyLogoMethod = 'POST' as const;
export const getSetCompanyLogoUrl = (_params?: SetCompanyLogoPathParameters) => SetCompanyLogoUrl;
